// import React from 'react';
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  clearCart,
} from '../../redux/features/cartSlice';
import { AiOutlinePlus, AiOutlineMinus, AiOutlineDelete } from 'react-icons/ai';

import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";

import { getClientID } from "../../services/clientCode";

import { requestOrderPlace } from '../../services/requestOrderPlace'
import { toast } from "react-toastify";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);

  const { client_code } = useParams();

  const [linkID, setLinkID] = useState(null);

  const handleOrderPlace = async () => {
    try {
      if (cartItems.length === 0) {
        toast.error("Your cart is empty! ❌");
        return;
      }
      // Calculate total weight
      const totalWeight = cartItems.reduce((total, item) => {
        const itemWeight = parseFloat(item.weight || 0);
        const quantity = item.quantity || 0;
        return total + itemWeight * quantity;
      }, 0);
      // Prepare the payload with cartItems and totalWeight
      const payload = {
        cartItems,
        linkID,
        totalWeight: totalWeight.toFixed(2),
      };
      const response = await requestOrderPlace(JSON.stringify(payload));
      if (response?.status === 200) {
        toast.success(`Order placed successfully! ✅`);
        dispatch(clearCart());
      } else {
        throw new Error('Unexpected response from server.');
      }
    } catch (error) {
      console.error('Error placing order:', error);
      toast.error("Failed to place order. Please try again. ❌");
    }
  };

  const getClientData = async () => {
    try {
      const data = { code: client_code };
      const response = await getClientID(data);
      if (response?.status) {
        const result = response?.data?.data;
        // console.log('result', result?.URL?.link_id);
        setLinkID(result?.URL?.link_id)
      }
    } catch (error) {
      console.log("Error fetching client data:", error);
    }
  };
  useEffect(() => {
    getClientData();
  }, []);



  return (
    <div className="">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-lg font-bold">🛒 Your Cart Item</h1>
        {/* <div className="col-span-12">
          <button type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center border border-indigo-300 px-2 py-1 rounded-md bg-[#AD826D] text-white hover:bg-white-50">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" className="h-4 w-4">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18">
              </path>
            </svg>
            <span className="ml-1 font-bold text-sm">Back</span>
          </button>
        </div> */}
      </div>
      {cartItems.length === 0 ? (
        <p className="text-gray-600">Your cart is empty.</p>
      ) : (
        <>
          {/* Cart Items List */}
          <div className="grid grid-cols-12 gap-4 space-y-2">
            {cartItems.map((item) => (
              <div
                key={item.id}
                className="col-span-12 md:col-span-4  flex items-center justify-between bg-white p-2 shadow-md rounded-lg gap-2"
              >
                {/* Product Image */}
                <img
                  src={item.image}
                  alt={item.title}
                  width={100}
                  className="w-[100px] h-[80px] object-cover rounded-md"
                />
                {/* Product Details */}
                <div className="flex-1 ml-4">
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                  {item.weight && (
                    // <p className="text-gray-500 text-sm">Weight: {item.weight}</p>
                    <p className="text-gray-500 text-sm">Total Weight: {(parseFloat(item.weight) * (item?.quantity || 0)).toFixed(3)} gm</p>
                  )}
                  <div className="flex items-center space-x-3 gap-3 justify-between">
                    <div className="flex items-center space-x-2 border rounded-3xl my-2">
                      <button
                        onClick={() => dispatch(decrementQuantity({ id: item.id }))}
                        className="text-dark px-2 py-1 rounded-md"
                      >
                        −
                      </button>
                      <span className="text-sm font-bold">{item.quantity}</span>
                      <button
                        onClick={() => dispatch(incrementQuantity({ id: item.id }))}
                        className="text-dark px-2 py-1 rounded-md"
                      >
                        +
                      </button>
                    </div>
                    {/* Remove Item Button */}
                    <button
                      onClick={() => dispatch(removeFromCart({ id: item.id }))}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 p-2 rounded-full"
                    >
                      <AiOutlineDelete size={18} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {/* {cartItems.length > 0 && (
        <div className="flex relative py-4 items-center justify-end">
          <button
            onClick={handleOrderPlace}
            className="w-full bg-[#AD826D] text-white py-2 px-4 rounded-3xl hover:opacity-75 text-sm font-semibold"
          >
            Total Weight:{" "}
            {
              cartItems.reduce((total, item) => {
                const itemWeight = parseFloat(item.weight || 0);
                const quantity = item.quantity || 0;
                return total + itemWeight * quantity;
              }, 0).toFixed(2)
            }{" "}
            gm <br></br> Order Place
          </button>
        </div>
      )} */}
      {cartItems.length > 0 && (
        <div className='flex relative py-4 items-center justify-end'>
          <button
            onClick={handleOrderPlace}
            className="w-full bg-[#AD826D] text-white py-2 px-4 rounded-3xl hover:opacity-75"
          >
            {/* Order Place */}
            Checkout Order
          </button>
        </div>
      )}
    </div>
  );
};

export default Cart;
